import React, { useState } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Pagination, PaginationItem, Box
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

// Dummy data
const tableData = Array.from({ length: 35 }, (_, i) => ({
  date: `2025-06-${(i + 1).toString().padStart(2, "0")}`,
  username: `user_${i + 1}`,
  deposited: Math.floor(Math.random() * 1000),
  validBet: Math.floor(Math.random() * 2000),
  status: i % 2 === 0 ? "Active" : "Inactive",
}));

const InviteeTable = () => {
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const pageCount = Math.ceil(tableData.length / rowsPerPage);
  const { t } = useTranslation();

  const handlePageChange = (_, value) => {
    setPage(value);
  };

  const paginatedData = tableData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const summary = paginatedData.reduce(
    (acc, row) => ({
      deposited: acc.deposited + row.deposited,
      validBet: acc.validBet + row.validBet,
    }),
    { rewards: 0, deposited: 0, validBet: 0 }
  );

  return (
    <Paper sx={{ backgroundColor: "white", mt: 4 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>{t("referral.registerdate")}</strong></TableCell>
              <TableCell><strong>{t("referral.username")}</strong></TableCell>
              <TableCell align="center"><strong>{t("referral.targetdeposit")}</strong></TableCell>
              <TableCell align="center"><strong>{t("referral.targetvalidbet")}</strong></TableCell>
              <TableCell><strong>{t("referral.status")}</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
           {paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {t("referral.norecords")}
                </TableCell>
              </TableRow>
            ) : (
              <>
                {paginatedData.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.username}</TableCell>
                    <TableCell align="center">{row.deposited.toLocaleString()}</TableCell>
                    <TableCell align="center">{row.validBet.toLocaleString()}</TableCell>
                    <TableCell>{row.status}</TableCell>
                  </TableRow>
                ))}
                    <TableRow>
                    <TableCell colSpan={2}><strong>Total Users : {paginatedData.length}</strong></TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell colSpan={2}><strong>Grand Total :</strong></TableCell>
                    <TableCell align="center"><strong>{summary.deposited.toLocaleString()}</strong></TableCell>
                    <TableCell align="center"><strong>{summary.validBet.toLocaleString()}</strong></TableCell>
                    <TableCell />
                    </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination controls */}
      <Box display="flex" justifyContent="flex-end" py={2} pr={2}>
        <Pagination
          count={pageCount}
          page={page}
          onChange={handlePageChange}
          color="primary"
          siblingCount={1}        // max 1 sibling around the current page
          boundaryCount={1}       // show first and last page numbers
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{
                previous: ArrowBack,
                next: ArrowForward,
              }}
              sx={{
                '& svg': { color: 'black' }, // Make arrow icons black
              }}
            />
          )}
        />
      </Box>
    </Paper>
  );
};

export default InviteeTable;
